import React from "react";
import { PostLogin } from "../component/Header";
import { RouteComponentProps } from "react-router-dom";
import { NewBroadcastMain } from "../component/Broadcast/NewBroadcastMain";
import { useRequireRBAC } from "../component/shared/useRequireRBAC";
import { PERMISSION_KEY } from "../types/Rbac/permission";

function NewBroadcast({ match, history }: RouteComponentProps<any>) {
  const { id } = match.params;

  useRequireRBAC(
    id ? [PERMISSION_KEY.broadcastEdit] : [PERMISSION_KEY.broadcastCreate]
  );

  let newBroadcastMatchState = history.location.state as {
    matchedListIds: number[] | undefined;
  };

  return (
    <div className="post-login">
      <PostLogin selectedItem={"Campaigns"} />
      <NewBroadcastMain
        id={id}
        contactListIds={newBroadcastMatchState?.matchedListIds ?? []}
      />
    </div>
  );
}

export default NewBroadcast;
